// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\Auth\DataProviders\AbilityAction
// Generated on: 2025-10-13 05:02:02

export enum AbilityAction {
  DELETE = 'delete',
  READ = 'read',
  CREATE = 'create',
  UPDATE = 'update',
}

export const AbilityActionCases = ["delete", "read", "create", "update"] as const;

/* Aliases */
export const Action = AbilityAction;
export const A = AbilityAction;
